<mat-card class="invoice-container mat-elevation-z8">
  <div class="container">
    <div class="top-info">
      <div class="left-side">
        <div class="logo">
          <img *ngIf="showInvoiceHeader && topLevelUser?.company_logo" src="{{topLevelUser?.company_logo}}" alt="logo">
        </div>
        <br>
        <br>
        <br>
        <br>
        <div class="bill-to">
          <div class="title-header">
            <span class="bill-text">BILL TO</span>
          </div>

          <div class="content">
            <h2>{{ invoiceUserData?.company }}</h2>
            <span>{{ invoiceUserData?.address }}</span>
            <span>Tel: {{ invoiceUserData?.phone }}</span>
            <span>Email: {{ invoiceUserData?.email }}</span>
            <span>VAT/ TAX ID # {{ invoiceUserData?.vat_tax_id }}</span>
          </div>
        </div>
      </div>
      <div class="right-side">
        <div class="invoice-detail">
          <h3>INVOICE # <span> {{ invoiceDetails?.invoice_code }}</span></h3>
          <table>
            <tr class="th">
              <th>DATE</th>
              <th>DUE DATE</th>

            </tr>
            <tr>
              <td> {{ invoiceDetails?.invoice_date | date: 'MM/dd/yyyy' }}</td>
              <td> {{ invoiceDetails?.invoice_date | date: 'MM/dd/yyyy' }}</td>
            </tr>
            <tr>
              <td>FROM</td>
              <td>TO</td>
            </tr>
            <tr>
              <td>{{ invoiceDetails?.utc_from | date: 'MM/dd/yyyy HH:mm:ss' }}</td>
              <td>{{ invoiceDetails?.utc_to | date: 'MM/dd/yyyy HH:mm:ss' }}</td>
            </tr>
            <tr>
              <td><span *ngIf="getLocalTimezone() != 'America/Los_Angeles' && invoiceDetails">LOCAL TIME ZONE</span>
              </td>
              <td>TOTAL DUE</td>
            </tr>
            <tr>
              <td> <span *ngIf="getLocalTimezone() != 'America/Los_Angeles' && invoiceDetails">{{ getLocalTimezone()
                  }}</span></td>
              <td>{{ invoiceDetails?.currency?.symbol }}{{ calcTotal()|number }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>

  </div>
  <!-- <div class="bill-wrapper">
    <div class="section info-wrap">
      <div class="logo">
        <img *ngIf="showInvoiceHeader && topLevelUser?.company_logo"  src="{{topLevelUser?.company_logo}}" alt="logo">
      </div>
      <div class="divider"></div>
    </div>
    <div class="section title" *ngIf="showInvoiceHeader">
      <h2>{{ topLevelUser?.company }}</h2>
      <div class="title-data">
        <div>
          <span>{{ topLevelUser?.address }}</span>
          <span><b>Email: </b>{{ topLevelUser?.email }}</span>
          <span> {{ topLevelUser?.phone }}</span>
        </div>
      </div> -->
  <!-- <h2>{{ invoiceDetails?.user.company }}</h2>
      <div class="title-data">
        <div>
          <span>SUBMITTED DATE</span>
          <span>FROM</span>
          <span>TO</span>
          <span *ngIf="getLocalTimezone() != 'America/Los_Angeles' && invoiceDetails">LOCAL TIME ZONE</span>
          <span>TOTAL DUE</span>
        </div>
        <div>
          <span>{{ invoiceDetails?.invoice_date | date: 'MM/dd/yyyy' }} (USA/Los Angeles)</span>
          <span>{{ invoiceDetails?.utc_from | date: 'MM/dd/yyyy HH:mm:ss' }}</span>
          <span> {{ invoiceDetails?.utc_to | date: 'MM/dd/yyyy HH:mm:ss' }}</span>
          <span *ngIf="getLocalTimezone() != 'America/Los_Angeles' && invoiceDetails">{{ getLocalTimezone() }}</span>
          <span>{{ invoiceDetails?.currency?.symbol }}{{ calcTotal()|number }}</span>
        </div>
      </div> -->
  <!-- </div>
  </div> -->
  <!-- <div class="bill-wrapper">
    <div class="section">
      <h3>BILL TO</h3>
      <span>{{ invoiceUserData?.company }}</span>
      <span>{{ invoiceUserData?.address }}</span>
      <span>Tel: {{ invoiceUserData?.phone }}</span>
      <span>Email: {{ invoiceUserData?.email }}</span>
      <span>VAT/ TAX ID # {{ invoiceUserData?.vat_tax_id }}</span>
    </div>
    <div class="section">
      <h3>INVOICE DETAILS</h3>
      <span>INVOICE # {{ invoiceDetails?.invoice_code }}</span>
      <span *ngIf="piNumber">PI Number: {{ piNumber }}</span>
      <span>Issue Date: {{ invoiceDetails?.invoice_date | date: 'MM/dd/yyyy' }}</span>
      <span>Location time zone: (USA/Los Angeles)</span>
      <span>Total Due: {{ invoiceDetails?.currency?.symbol }}{{ calcTotal()|number }}</span>
    </div>
  </div> -->


  <table class="simple invoice-table" id="invoice-table">
    <thead>
      <tr>
        <th *ngFor="let title of titles">{{title}}</th>
        <!-- <th></th> -->
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let invoice of invoiceItems;let i = index">
        <td>{{i+1}}</td>
        <!-- <td>
          {{invoice.buyer.company}}
        </td> -->
        <td>
          <span *ngIf="invoice.product">
            {{invoice.product.title}} - {{invoice.product.currency_data.symbol}}{{ invoice.unit_price_original || invoice.original_price | number }}
          </span>
                    <span *ngIf="!invoice.product">
            {{invoice?.crypto_order?.crypto_currency_data.code}}
          </span>
                </td>
                <td>
                    {{invoice.count}}
                </td>
                <td>
                    {{ invoiceDetails?.currency?.symbol }}{{ invoice.unit_price }}

                </td>
                <td>
                    {{ invoiceDetails?.currency?.symbol }}{{ invoice.unit_price * invoice.count | number }}
                    <small class="buyer-company">
            ({{invoice.buyer.company}})
          </small>
                </td>
                <!-- <td>
        </td> -->
      </tr>
    </tbody>
  </table>

  <div class="flex-end" id="total">
    <table class="simple invoice-table-footer">
      <tbody>
        <tr class="subtotal">
          <td>SUB TOTAL: {{ invoiceDetails?.currency?.symbol }}{{ calcTotal()|number }}</td>
          <td></td>
        </tr>
        <tr class="total">
          <td>TOTAL DUE: {{ invoiceDetails?.currency?.symbol }}{{ calcTotal()|number }}</td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="print-page" #printPage>
    <div class="fixed-image-container">
      <img src="/assets/images/bg-pattern.png">
      <div class="wrapper overlay-text" *ngIf="showInvoiceHeader">
        <div><span class="title-badge">COMPANY</span><span>{{ topLevelUser?.company }}</span></div>
        <div><span class="title-badge">ADDRESS</span><span>{{ topLevelUser?.address }}</span></div>
        <div><span class="title-badge">EMAIL</span><span>{{ topLevelUser?.email }}</span></div>
        <div><span class="title-badge">PHONE</span><span>{{ topLevelUser?.phone }}</span></div>
      </div>
    </div>
  </div>




    <div class="footer" *ngIf="false">
        <!-- <div class="note">Please pay within 15 days. Thank you for your business.</div> -->
        <div class="footer-wrap">
            <div class="logo">
                <img [src]="environmentConfig.logoSrc">
            </div>
            <div class="small-note">
                EZ Pin solutions provide the tools and resources you need to launch and manage your digital gift card programs successfully and securely. Our solutions enable your business to implement effective strategies to reach and acquire new customers while
                providing your customers with more choices and opportunities for redemption.
            </div>
        </div>
    </div>
</mat-card>